import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bubble-1",
  "use": "bubble-1-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"bubble-1\"><path d=\"M256 96c-27.466 0-53.994 4.331-78.847 12.871-23.356 8.027-44.153 19.372-61.814 33.722C82.232 169.492 64 204.085 64 240c0 20.149 5.594 39.689 16.626 58.076 11.376 18.96 28.491 36.293 49.494 50.126a63.997 63.997 0 0 1 28.088 43.947 161.8 161.8 0 0 1 1.685 18.062 159.005 159.005 0 0 0 10.94-9.988 64.007 64.007 0 0 1 53.329-18.233A253.423 253.423 0 0 0 256 384c27.467 0 53.994-4.33 78.847-12.871 23.356-8.027 44.153-19.372 61.814-33.722C429.768 310.509 448 275.915 448 240s-18.232-70.508-51.339-97.407c-17.661-14.349-38.458-25.695-61.814-33.722C309.994 100.331 283.467 96 256 96zm0-64c141.385 0 256 93.125 256 208S397.385 448 256 448c-13.578 0-26.905-.867-39.912-2.522C161.099 500.467 95.463 510.328 32 511.776v-13.458c34.268-16.789 64-47.37 64-82.318 0-4.877-.379-9.665-1.082-14.348C37.02 363.52 0 305.275 0 240 0 125.125 114.615 32 256 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bubble-1.svg
// module id = 3HdP
// module chunks = 1